// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3dq1u","content":"GlobalSearch_content__2DM_G"};